import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { clsx } from 'clsx'

import type { CancellationOptionProps } from './CancellationOption.types'

export const CancellationOption = (props: CancellationOptionProps) => {
  const {
    description,
    e2eSelector,
    icon,
    isSelected,
    name,
    onChange,
    title,
    value,
  } = props

  return (
    <label
      className={clsx(
        'CancellationOption d-flex gap-4 w-100 px-4 py-3 border rounded-4 text-start',
        isSelected && 'CancellationOption--selected',
      )}
      data-e2e={e2eSelector}
    >
      <input
        checked={isSelected}
        className="visually-hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />
      <div className="CancellationOption-icon align-self-center flex-shrink-0">
        <FontAwesomeIcon aria-hidden="true" icon={icon} />
      </div>
      <div>
        <div className="CancellationOption-title fw-semibold">{title}</div>
        <p className="CancellationOption-description mb-0 small">
          {description}
        </p>
      </div>
    </label>
  )
}
